import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import Signature from '../Signature';
import styles from './SignatureWithProgress.module.scss';
export function SignatureWithProgress(param) {
    let { children, percent } = param;
    const [maxWidthValue, setMaxWidthValue] = useState(0);
    const frontRef = useCallback((node)=>{
        if (node) {
            setMaxWidthValue(node.getBoundingClientRect().width);
        }
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        children: [
            /*#__PURE__*/ _jsx(Signature, {
                className: styles.back,
                children: children
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: frontRef,
                style: {
                    clip: percent >= 1 ? undefined : "rect(auto, ".concat(maxWidthValue * percent, "px, auto, auto)")
                },
                className: styles.front,
                children: /*#__PURE__*/ _jsx(Signature, {
                    children: children
                })
            })
        ]
    });
}
